export const ADMIN_BASE_PATH = "/doufengad";
